import { z } from 'zod';
import i18next from 'i18next';

export const emailTemplateSchema = z.object({
  id: z.string().optional(),
  platformTemplateId: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('emailTemplate:templateIdRequired'),
        });
      }
    }),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:nameRequired'),
      });
    }
  }),
  type: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:typeRequired'),
      });
    }
  }),
  active: z.boolean().default(true),
});

export type TEmailTemplateSchema = z.infer<typeof emailTemplateSchema>;
